import { render, staticRenderFns } from "./PuiSelectDetailDialog.vue?vue&type=template&id=bc078c2a"
import script from "./PuiSelectDetailDialog.vue?vue&type=script&lang=js"
export * from "./PuiSelectDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports